import styled from 'styled-components'

import { baseBreadcrumbStyles } from './BaseBreadcrumbStyles'

export const BreadcrumbStyled = styled.span`
  ${baseBreadcrumbStyles}
`
